import React, { useMemo, useState, useEffect } from 'react';
import {
  Row,
  Container,
  Col,
  InputGroup,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
} from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { redirect } from '../actions';
import { checkRegisteredUser, resetUser } from '../actions/OktaActions';
import squareLogo from '../assets/squareLogo.jpg';

const PreLogin = (props) => {
  const [email, setEmail] = useState(props.previousEmail);

  useEffect(() => {
    const user = {
      email,
    };
    if (props.emailAlreadyRegistered) {
      return props.redirect('/login');
    }
    if (props.emailNoClientFound) {
      props.resetUser(user);
      return props.redirect('/register');
    }
  }, [props.emailAlreadyRegistered, props.emailNoClientFound]);

  const isEmailInvalid = useMemo(() => {
    const validEmailPattern =
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (validEmailPattern.test(email) && email?.length > 5) {
      return false;
    }
    return true;
  }, [email]);

  const handleFoward = () => {
    const user = {
      email,
    };
    props.checkRegisteredUser(user);
    return false;
  };

  if (props.authenticated) {
    return props.redirect('/portfolios');
  }
  return (
    <div className="authContainer">
      <div className="imgContainer">
        <img className="background" src={'/background.jpg'} alt="building" />
      </div>

      <Container className="widgetContainer" fluid>
        <Row>
          <Col>
            <div className="clientHub">
              <div className="logo" />
            </div>
          </Col>
        </Row>
        <div className="card email">
          <div className="okta-sign-in-header auth-header">
            <img src={squareLogo} className="auth-org-logo" alt="NEPC" />
          </div>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
              handleFoward();
            }}>
            <FormGroup>
              <Label for="email-input">Please input your Email</Label>
              <InputGroup
                id="email-input"
                onSelect={(_props) =>
                  (_props.currentTarget.className = `${_props.currentTarget.className} selected`)
                }
                onBlur={(_props) =>
                  (_props.currentTarget.className =
                    _props.currentTarget.className.replace('selected', ''))
                }>
                <Input
                  name="email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="email"
                  autoFocus
                />
                <Button
                  color="primary"
                  onClick={handleFoward}
                  disabled={isEmailInvalid}>
                  <i className="fa-solid fa-right-to-bracket"></i>
                </Button>
              </InputGroup>
            </FormGroup>
            <div className="advice-text">
              Don’t want to see this page again? Bookmark your
              <Link to="/portfolios">{' Portfolio '}</Link>
              page and you will automatically be redirected to your login.
            </div>
          </Form>
        </div>
        <div className="terms-link">
          <a href="/terms" className="nav-link">
            Terms and Conditions
          </a>
        </div>
      </Container>
    </div>
  );
};

PreLogin.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  checkRegisteredUser: PropTypes.func.isRequired,
  previousEmail: PropTypes.string.isRequired,
  redirect: PropTypes.func.isRequired,
  // Status
  emailNoClientFound: PropTypes.bool.isRequired,
  emailAlreadyRegistered: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string,
  resetUser: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { okta } = state;
  return {
    authenticated: !!okta.user,
    previousEmail: okta.registering.user.email || '',
    emailNoClientFound: okta.registering.emailNoClientFound,
    emailAlreadyRegistered: okta.registering.emailAlreadyRegistered,
    success: okta.registering.success,
    error: okta.registering.error,
    loading: state.ui.isLoading,
    redirectTo: state.ui.redirect,
  };
};

export default connect(mapStateToProps, {
  checkRegisteredUser,
  redirect,
  resetUser,
})(PreLogin);
